import { Controller } from "@hotwired/stimulus"

// Rotates the "OVERLAND" wordmark through a series of typographic treatments,
// mirroring the animated hero on overlandmusicgroup.com. Each specimen class
// (m-*) is defined in the landing page's scoped <style> block.
export default class extends Controller {
  static targets = ["layer"]
  static values = {
    word: { type: String, default: "OVERLAND" },
    dwell: { type: Number, default: 2200 }
  }

  connect() {
    this.specimens = [
      { cls: "m-monolith" }, { cls: "m-engraved" }, { cls: "m-blackletter" }, { cls: "m-spur" },
      { cls: "m-ornate" }, { cls: "m-condensed" }, { cls: "m-tall" }, { cls: "m-disco" },
      { cls: "m-outrun" }, { cls: "m-chrome" }, { cls: "m-mono" }, { cls: "m-deco" },
      { cls: "m-limelight" }, { cls: "m-fashion" }, { cls: "m-editorial" }, { cls: "m-script" },
      { cls: "m-retro" }, { cls: "m-marker" }, { cls: "m-ransom", letters: true }, { cls: "m-spray" },
      { cls: "m-wet" }, { cls: "m-glitch" }, { cls: "m-molten" }, { cls: "m-iso" },
      { cls: "m-vinyl" }, { cls: "m-stencil" }, { cls: "m-bubble" }, { cls: "m-outline" },
      { cls: "m-whisper" }, { cls: "m-shadow" },
      // musica mexicana
      { cls: "m-rancho" }, { cls: "m-corrido" }, { cls: "m-sierreno" },
      // nu metal
      { cls: "m-numetal" }, { cls: "m-dripped" }, { cls: "m-rapmetal" }
    ]
    this.ransomFonts = ["'Anton'", "'Archivo Black'", "'Bebas Neue'", "Georgia, serif", "'Black Ops One'", "'Rye'"]

    this.idx = 0
    this.front = 0
    this.timer = null

    this.onVisibility = () => {
      if (document.hidden) {
        clearTimeout(this.timer)
      } else {
        this.schedule()
      }
    }
    document.addEventListener("visibilitychange", this.onVisibility)

    // Respect reduced-motion: show the first specimen and stop.
    this.reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.init()
  }

  disconnect() {
    clearTimeout(this.timer)
    document.removeEventListener("visibilitychange", this.onVisibility)
  }

  init() {
    const s0 = this.specimens[0]
    const first = this.layerTargets[0]
    first.className = "mark " + s0.cls
    this.renderWord(first.querySelector(".word"), s0)
    void first.offsetWidth
    first.classList.add("active")
    if (!this.reduced) this.schedule()
  }

  renderWord(el, s) {
    el.className = "word"
    if (s.letters) {
      el.textContent = ""
      this.wordValue.split("").forEach((ch, i) => {
        const sp = document.createElement("span")
        sp.textContent = ch === " " ? " " : ch
        sp.style.fontFamily = this.ransomFonts[i % this.ransomFonts.length]
        sp.style.transform = "rotate(" + (((i * 37) % 9) - 4) + "deg)"
        sp.style.color = (i % 3 === 0) ? "#111" : "#efeee9"
        sp.style.background = (i % 3 === 0) ? "#efeee9" : "transparent"
        sp.style.padding = "0 .06em"
        sp.style.margin = "0 .012em"
        el.appendChild(sp)
      })
    } else {
      el.textContent = this.wordValue
    }
  }

  show(i) {
    this.idx = (i + this.specimens.length) % this.specimens.length
    const s = this.specimens[this.idx]
    const back = this.layerTargets[1 - this.front]
    const cur = this.layerTargets[this.front]

    back.className = "mark " + s.cls
    this.renderWord(back.querySelector(".word"), s)
    void back.offsetWidth
    back.classList.add("active")

    cur.classList.remove("active")
    cur.classList.add("leave")
    setTimeout(() => cur.classList.remove("leave"), 460)

    this.front = 1 - this.front
    this.schedule()
  }

  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.show(this.idx + 1), this.dwellValue)
  }
}
